module.exports = __webpack_public_path__ + "static/media/telegram-black.2ece0f03.svg";